<template>
  <div id="zj-component-starttasklist" class="zj-emergency-starttask-list select-none">
    <div>采用预案：{{this.planName}}</div>
    <div>
      <div>
        <el-table :data="tableData" :show-header="false" stripe="false">
          <el-table-column>
            <template slot-scope="scope">
              <div class="task-row select-none">
                <div class="task-row-1">
                  <div class="seq">{{scope.$index + 1}}、</div>
                  <div class="detail">{{scope.row.TaskTiltle}}</div>
                  <div class="tag" :v-if="scope.row.ExecWay == 1">预案任务</div>
                  <div :class="statusClass(scope.row)">{{ convertStatus(scope.row)}}</div>
                </div>
                <div class="task-row-2">
                  <div class="contact">{{scope.row.ChargerName}}</div>
                  <div class="phone">{{scope.row.Phone}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import Constant from "../config/constant";

//import MyApis from "../../../../apis";

export default {
  name: "ZJEmergencyComponentStartTaskList",
  componentName: "ZJEmergencyComponentStartTaskList",
  components: {},
  props: {
    tableData: Object,
    planName: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      isVisiable: false
    };
  },
  methods: {
    statusClass: function(row) {
      return {
        status: true,
        processing:
          row.TaskStatus == Constant.TaskStatus.Todo.desc ||
          row.TaskStatus == Constant.TaskStatus.Todo.code ||
          row.TaskStatus == Constant.TaskStatus.Processing.desc ||
          row.TaskStatus == Constant.TaskStatus.Processing.code,
        startfailed:
          row.TaskStatus == Constant.TaskStatus.Exception.desc ||
          row.TaskStatus == Constant.TaskStatus.Exception.code,
        finished:
          row.TaskStatus == Constant.TaskStatus.Done.desc ||
          row.TaskStatus == Constant.TaskStatus.Done.code ||
          row.TaskStatus == Constant.TaskStatus.Closed.desc ||
          row.TaskStatus == Constant.TaskStatus.Closed.code
      };
    },
    convertStatus: function(row) {
      var status = "";
      if (
        row.TaskStatus == Constant.TaskStatus.Todo.desc ||
        row.TaskStatus == Constant.TaskStatus.Todo.code ||
        row.TaskStatus == Constant.TaskStatus.Processing.desc ||
        row.TaskStatus == Constant.TaskStatus.Processing.code
      ) {
        status = "执行中";
      } else if (
        row.TaskStatus == Constant.TaskStatus.Done.desc ||
        row.TaskStatus == Constant.TaskStatus.Done.code ||
        row.TaskStatus == Constant.TaskStatus.Closed.desc ||
        row.TaskStatus == Constant.TaskStatus.Closed.code
      ) {
        status = "已完成";
      } else {
        status = "启动失败";
      }
      return status;
    }
  }
};
</script>